import { useState } from 'react';
import { Wheat, Check } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '@/lib/api';
import { formatQ } from './yieldConstants';

export function HarvestInput({ estimateId, actual, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(actual?.quintali ?? '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const q = parseFloat(String(value).replace(',', '.'));
    if (!(q > 0)) { toast.error('Inserisci i quintali raccolti'); return; }
    setSaving(true);
    try {
      const { data } = await api.put(`/ai/yield-history/${estimateId}/harvest`, { quintali: q });
      onSaved(data);
      setEditing(false);
      toast.success('Raccolto salvato: le prossime stime useranno questo dato');
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  if (editing) return (
    <div className="mt-4 flex gap-2" data-testid={`harvest-form-${estimateId}`}>
      <input type="number" min="0" step="0.1" autoFocus value={value} onChange={e => setValue(e.target.value)}
        placeholder="Quintali raccolti" data-testid={`harvest-input-${estimateId}`}
        className="flex-1 min-w-0 h-9 rounded-full bg-secondary/60 border border-border px-4 text-sm focus:outline-none focus:border-chartreuse"/>
      <button onClick={save} disabled={saving} data-testid={`harvest-save-${estimateId}`}
        className="h-9 px-4 rounded-full bg-chartreuse text-black text-xs font-bold transition-opacity hover:opacity-90 disabled:opacity-50 inline-flex items-center gap-1">
        <Check size={13}/> Salva
      </button>
    </div>
  );

  if (actual) {
    const s = actual.scarto_pct;
    const good = s != null && Math.abs(s) <= 10;
    return (
      <button onClick={() => setEditing(true)} data-testid={`harvest-actual-${estimateId}`}
        className="mt-4 w-full text-left rounded-xl border border-border bg-secondary/40 px-3 py-2 text-xs transition-colors hover:border-chartreuse/40">
        <span className="text-muted-foreground">Raccolto reale </span><span className="font-bold">{formatQ(actual.quintali)}</span>
        {s != null && <span className={`ml-2 font-bold ${good ? 'text-chartreuse' : 'text-terracotta'}`}>scarto {s >= 0 ? '+' : ''}{s}%</span>}
      </button>
    );
  }

  return (
    <button onClick={() => setEditing(true)} data-testid={`harvest-add-${estimateId}`}
      className="mt-4 w-full h-9 rounded-full border border-dashed border-chartreuse/40 text-xs text-chartreuse inline-flex items-center justify-center gap-1.5 transition-colors hover:bg-chartreuse/10">
      <Wheat size={13}/> Inserisci raccolto reale
    </button>
  );
}
